import { StandardTextFieldProps } from '@mui/material';
import { ITextField } from 'components';
import { InputFieldProps } from 'types';
import { useFormRules } from 'utils';

const FeedbackTitleField = ({
	control,
}: InputFieldProps & StandardTextFieldProps) => {
	const { formRules } = useFormRules();

	return (
		<ITextField
			control={control}
			name="feedbackTitle"
			type="text"
			rules={formRules.requiredField}
		/>
	);
};

export default FeedbackTitleField;
